import subscriptions from "./subscriptions";

export default subscriptions;
